// This file is auto-generated by `rake view_components:update_js_index`

import { Stimulus } from "../assets/javascripts/stimulus"
const application = Stimulus;

import ApplicationComponentController from "./application_component_controller"
application.register("application-component", ApplicationComponentController)

import ArchiveDestinations__StreamPickerComponentController from "./archive_destinations/stream_picker_component_controller"
application.register("archive-destinations--stream-picker-component", ArchiveDestinations__StreamPickerComponentController)

import CodeComponentController from "./code_component_controller"
application.register("code-component", CodeComponentController)

import DialogComponentController from "./dialog_component_controller"
application.register("dialog-component", DialogComponentController)

import DropdownComponent__SearchController from "./dropdown_component/search_controller"
application.register("dropdown-component--search", DropdownComponent__SearchController)

import DropdownComponentController from "./dropdown_component_controller"
application.register("dropdown-component", DropdownComponentController)

import Error__DataFormatterComponentController from "./error/data_formatter_component_controller"
application.register("error--data-formatter-component", Error__DataFormatterComponentController)

import Insights__AddWidgetComponentController from "./insights/add_widget_component_controller"
application.register("insights--add-widget-component", Insights__AddWidgetComponentController)

import Insights__AlarmEditComponentController from "./insights/alarm_edit_component_controller"
application.register("insights--alarm-edit-component", Insights__AlarmEditComponentController)

import Insights__Alarms__PreviewChartComponentController from "./insights/alarms/preview_chart_component_controller"
application.register("insights--alarms--preview-chart-component", Insights__Alarms__PreviewChartComponentController)

import Insights__BadgerqlTranslator__FormComponentController from "./insights/badgerql_translator/form_component_controller"
application.register("insights--badgerql-translator--form-component", Insights__BadgerqlTranslator__FormComponentController)

import Insights__BallBounceLoaderComponentController from "./insights/ball_bounce_loader_component_controller"
application.register("insights--ball-bounce-loader-component", Insights__BallBounceLoaderComponentController)

import Insights__Config__BoxComponentController from "./insights/config/box_component_controller"
application.register("insights--config--box-component", Insights__Config__BoxComponentController)

import Insights__Config__ComboboxComponentController from "./insights/config/combobox_component_controller"
application.register("insights--config--combobox-component", Insights__Config__ComboboxComponentController)

import Insights__Config__FieldGroupsComponentController from "./insights/config/field_groups_component_controller"
application.register("insights--config--field-groups-component", Insights__Config__FieldGroupsComponentController)

import Insights__Config__RadioGroupComponentController from "./insights/config/radio_group_component_controller"
application.register("insights--config--radio-group-component", Insights__Config__RadioGroupComponentController)

import Insights__Config__ToggleComponentController from "./insights/config/toggle_component_controller"
application.register("insights--config--toggle-component", Insights__Config__ToggleComponentController)

import Insights__Dashboard__GridComponentController from "./insights/dashboard/grid_component_controller"
application.register("insights--dashboard--grid-component", Insights__Dashboard__GridComponentController)

import Insights__Dashboard__GridItemComponentController from "./insights/dashboard/grid_item_component_controller"
application.register("insights--dashboard--grid-item-component", Insights__Dashboard__GridItemComponentController)

import Insights__Dashboard__SwitcherComponentController from "./insights/dashboard/switcher_component_controller"
application.register("insights--dashboard--switcher-component", Insights__Dashboard__SwitcherComponentController)

import Insights__DashboardComponentController from "./insights/dashboard_component_controller"
application.register("insights--dashboard-component", Insights__DashboardComponentController)

import Insights__DocsComponentController from "./insights/docs_component_controller"
application.register("insights--docs-component", Insights__DocsComponentController)

import Insights__Query__BadgersenseComponentController from "./insights/query/badgersense_component_controller"
application.register("insights--query--badgersense-component", Insights__Query__BadgersenseComponentController)

import Insights__QueryComponentController from "./insights/query_component_controller"
application.register("insights--query-component", Insights__QueryComponentController)

import Insights__QueryStateComponentController from "./insights/query_state_component_controller"
application.register("insights--query-state-component", Insights__QueryStateComponentController)

import Insights__StreamSelectorComponentController from "./insights/stream_selector_component_controller"
application.register("insights--stream-selector-component", Insights__StreamSelectorComponentController)

import Insights__TabRailComponentController from "./insights/tab_rail_component_controller"
application.register("insights--tab-rail-component", Insights__TabRailComponentController)

import Insights__Vis__AreaChartComponentController from "./insights/vis/area_chart_component_controller"
application.register("insights--vis--area-chart-component", Insights__Vis__AreaChartComponentController)

import Insights__Vis__BarChartComponentController from "./insights/vis/bar_chart_component_controller"
application.register("insights--vis--bar-chart-component", Insights__Vis__BarChartComponentController)

import Insights__Vis__BaseComponentController from "./insights/vis/base_component_controller"
application.register("insights--vis--base-component", Insights__Vis__BaseComponentController)

import Insights__Vis__BillboardChartComponentController from "./insights/vis/billboard_chart_component_controller"
application.register("insights--vis--billboard-chart-component", Insights__Vis__BillboardChartComponentController)

import Insights__Vis__ChartComponentController from "./insights/vis/chart_component_controller"
application.register("insights--vis--chart-component", Insights__Vis__ChartComponentController)

import Insights__Vis__EventDetailsComponentController from "./insights/vis/event_details_component_controller"
application.register("insights--vis--event-details-component", Insights__Vis__EventDetailsComponentController)

import Insights__Vis__HandsfreeComponentController from "./insights/vis/handsfree_component_controller"
application.register("insights--vis--handsfree-component", Insights__Vis__HandsfreeComponentController)

import Insights__Vis__HeatmapChartComponentController from "./insights/vis/heatmap_chart_component_controller"
application.register("insights--vis--heatmap-chart-component", Insights__Vis__HeatmapChartComponentController)

import Insights__Vis__HistogramChartComponentController from "./insights/vis/histogram_chart_component_controller"
application.register("insights--vis--histogram-chart-component", Insights__Vis__HistogramChartComponentController)

import Insights__Vis__LegendComponentController from "./insights/vis/legend_component_controller"
application.register("insights--vis--legend-component", Insights__Vis__LegendComponentController)

import Insights__Vis__LineChartComponentController from "./insights/vis/line_chart_component_controller"
application.register("insights--vis--line-chart-component", Insights__Vis__LineChartComponentController)

import Insights__Vis__PieChartComponentController from "./insights/vis/pie_chart_component_controller"
application.register("insights--vis--pie-chart-component", Insights__Vis__PieChartComponentController)

import Insights__Vis__ScatterChartComponentController from "./insights/vis/scatter_chart_component_controller"
application.register("insights--vis--scatter-chart-component", Insights__Vis__ScatterChartComponentController)

import Insights__Vis__TableComponentController from "./insights/vis/table_component_controller"
application.register("insights--vis--table-component", Insights__Vis__TableComponentController)

import Insights__VisComponentController from "./insights/vis_component_controller"
application.register("insights--vis-component", Insights__VisComponentController)

import Insights__Widgets__AlarmsComponentController from "./insights/widgets/alarms_component_controller"
application.register("insights--widgets--alarms-component", Insights__Widgets__AlarmsComponentController)

import Insights__Widgets__CheckinsComponentController from "./insights/widgets/checkins_component_controller"
application.register("insights--widgets--checkins-component", Insights__Widgets__CheckinsComponentController)

import Insights__Widgets__ConfigPanelComponentController from "./insights/widgets/config_panel_component_controller"
application.register("insights--widgets--config-panel-component", Insights__Widgets__ConfigPanelComponentController)

import Insights__Widgets__DeploymentsComponentController from "./insights/widgets/deployments_component_controller"
application.register("insights--widgets--deployments-component", Insights__Widgets__DeploymentsComponentController)

import Insights__Widgets__DeploymentsConfigComponentController from "./insights/widgets/deployments_config_component_controller"
application.register("insights--widgets--deployments-config-component", Insights__Widgets__DeploymentsConfigComponentController)

import Insights__Widgets__ErrorsComponentController from "./insights/widgets/errors_component_controller"
application.register("insights--widgets--errors-component", Insights__Widgets__ErrorsComponentController)

import Insights__Widgets__InsightsVisConfigComponentController from "./insights/widgets/insights_vis_config_component_controller"
application.register("insights--widgets--insights-vis-config-component", Insights__Widgets__InsightsVisConfigComponentController)

import Insights__Widgets__UptimeComponentController from "./insights/widgets/uptime_component_controller"
application.register("insights--widgets--uptime-component", Insights__Widgets__UptimeComponentController)

import MultiSelectComponentController from "./multi_select_component_controller"
application.register("multi-select-component", MultiSelectComponentController)

import PanelsComponentController from "./panels_component_controller"
application.register("panels-component", PanelsComponentController)

import SlimSelectComponentController from "./slim_select_component_controller"
application.register("slim-select-component", SlimSelectComponentController)

import SubscriptionPlanPickerComponentController from "./subscription_plan_picker_component_controller"
application.register("subscription-plan-picker-component", SubscriptionPlanPickerComponentController)

import TimePickerComponentController from "./time_picker_component_controller"
application.register("time-picker-component", TimePickerComponentController)
